// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* Main */
  .main {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      min-width: 0;
      background: var(--surface);
  }

  .main-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 20px;
      background: var(--background);
      border-bottom: 1px solid var(--border);
  }

  .main-header__left {
      display: flex;
      align-items: center;
      gap: 12px;
  }

  .main-header__title {
      font-size: 16px;
      font-weight: 600;
      color: var(--text-primary);
  }

  .main-header__right {
      display: flex;
      align-items: center;
      gap: 8px;
  }

  .btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      padding: 8px 16px;
      border: none;
      border-radius: var(--radius-md);
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color var(--transition-fast), border-color var(--transition-fast);
  }

  .partner-btn--primary {
      background: linear-gradient(135deg, var(--partner-primary-500), var(--partner-primary-600));
      color: white;
  }

  .partner-btn--primary:hover {
      background: linear-gradient(135deg, var(--partner-primary-600), var(--partner-primary-700));
  }

  .btn--secondary {
      background: var(--background);
      border: 1px solid var(--border);
      color: var(--text-primary);
  }

  .btn--secondary:hover {
      background: var(--surface);
      border-color: var(--partner-primary-300);
  }

  .btn--danger {
      background: var(--error);
      color: white;
      transition: background-color var(--transition-fast);
  }

  .btn--danger:hover {
      background: var(--error-dark);
  }

  .btn--sm {
      padding: 6px 12px;
      font-size: 12px;
  }

  .main-content {
      flex: 1 1;
      overflow-y: auto;
      padding: 20px;
  }

  /* Tabs */
  .partner-tabs {
      display: flex;
      gap: 4px;
      background: var(--gray-100);
      padding: 4px;
      border-radius: var(--radius-lg);
      margin-bottom: 20px;
      width: fit-content;
  }

  .partner-tab {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 20px;
      border: none;
      background: transparent;
      border-radius: var(--radius-md);
      font-size: 13px;
      font-weight: 500;
      color: var(--text-secondary);
      cursor: pointer;
      transition: all 0.2s;
  }

  .partner-tab:hover {
      color: var(--text-primary);
  }

  .partner-tab--active {
      background: var(--background);
      color: var(--partner-primary-600);
      box-shadow: var(--shadow-sm);
  }

  .partner-tab__badge {
      min-width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--partner-primary-100);
      color: var(--partner-primary-600);
      font-size: 11px;
      font-weight: 600;
      border-radius: var(--radius-full);
      padding: 0 6px;
  }

  .partner-tab--active .partner-tab__badge {
      background: var(--partner-primary-600);
      color: white;
  }

  .partner-tab-content {
      display: none;
  }

  .partner-tab-content--active {
      display: block;
  }

  /* Stats Row */
  .stats-row {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;
      margin-bottom: 20px;
  }

  .stat-mini {
      background: var(--background);
      border: 1px solid var(--border);
      border-radius: var(--radius-lg);
      padding: 16px;
      display: flex;
      align-items: center;
      gap: 12px;
  }

  .stat-mini__icon {
      width: 40px;
      height: 40px;
      border-radius: var(--radius-md);
      display: flex;
      align-items: center;
      justify-content: center;
  }

  .stat-mini__icon--blue {
      background: var(--partner-primary-100);
      color: var(--partner-primary-600);
  }

  .stat-mini__icon--green {
      background: var(--success-light);
      color: var(--success);
  }

  .stat-mini__icon--purple {
      background: var(--primary-100);
      color: var(--primary-600);
  }

  .stat-mini__info {
      flex: 1 1;
  }

  .stat-mini__value {
      font-size: 20px;
      font-weight: 700;
      color: var(--text-primary);
  }

  .stat-mini__label {
      font-size: 12px;
      color: var(--text-tertiary);
  }

  /* Grid */
  .items-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 16px;
  }

  /* Agent Card */
  .agent-card {
      background: var(--background);
      border: 1px solid var(--border);
      border-radius: var(--radius-lg);
      padding: 20px;
      padding-left: 24px;
      transition: all 0.2s;
      position: relative;
  }

  /* .agent-card::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: var(--gray-300);
      border-radius: var(--radius-lg) 0 0 var(--radius-lg);
  } */

  .agent-card:hover {
      box-shadow: var(--shadow-md);
      border-color: var(--partner-primary-300);
  }

  /* Card Colors */
  .agent-card--purple::before {
      background: linear-gradient(180deg, #a855f7, #7c3aed);
  }

  .agent-card--blue::before {
      background: linear-gradient(180deg, #3b82f6, #2563eb);
  }

  .agent-card--teal::before {
      background: linear-gradient(180deg, #14b8a6, #0d9488);
  }

  .agent-card--green::before {
      background: linear-gradient(180deg, #22c55e, #16a34a);
  }

  .agent-card--orange::before {
      background: linear-gradient(180deg, #f97316, #ea580c);
  }

  .agent-card--pink::before {
      background: linear-gradient(180deg, #ec4899, #db2777);
  }

  .agent-card--red::before {
      background: linear-gradient(180deg, #ef4444, #dc2626);
  }

  .agent-card--indigo::before {
      background: linear-gradient(180deg, #6366f1, #4f46e5);
  }

  .agent-card>.partner-dropdown {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 2;
  }

  .agent-card__header {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin-bottom: 12px;
  }

  .agent-card__info {
      flex: 1 1;
      min-width: 0;
  }

  .agent-card__name {
      font-size: 15px;
      font-weight: 600;
      color: var(--text-primary);
      margin-bottom: 6px;
      display: flex;
      align-items: center;
      gap: 8px;
  }

  .agent-card__desc {
      font-size: 13px;
      color: var(--text-secondary);
      line-height: 1.5;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
  }

  .agent-card__menu {
      width: 32px;
      height: 32px;
      border: none;
      background: var(--background);
      border-radius: var(--radius-md);
      cursor: pointer;
      color: var(--text-tertiary);
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: var(--shadow-sm);
      flex-shrink: 0;
  }

  .agent-card__menu:hover {
      background: var(--gray-100);
      color: var(--text-primary);
  }

  .agent-card__meta {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 12px;
      flex-wrap: wrap;
  }

  .agent-card__tag {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 11px;
      font-weight: 500;
      padding: 4px 8px;
      border-radius: var(--radius-sm);
  }

  .agent-card__tag--model {
      background: var(--gray-100);
      color: var(--text-secondary);
  }

  .agent-card__tag--course {
      background: var(--partner-primary-50);
      color: var(--partner-primary-600);
  }

  .agent-card__footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 12px;
      border-top: 1px solid var(--border);
  }

  .agent-card__stat {
      font-size: 12px;
      color: var(--text-tertiary);
      display: flex;
      align-items: center;
      gap: 4px;
  }

  .agent-card__actions {
      display: flex;
      gap: 6px;
  }

  /* Template Card */
  .template-card {
      background: var(--background);
      border: 1px solid var(--border);
      border-radius: var(--radius-lg);
      /* overflow: hidden; */
      transition: all 0.2s;
  }

  .template-card:hover {
      box-shadow: var(--shadow-md);
  }

  .template-card__color {
      height: 4px;
  }

  .template-card__body {
      padding: 16px;
      /* min-height: 230px; */
  }

  .template-card__header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 12px;
  }

  .template-card__title {
      font-size: 14px;
      font-weight: 600;
      color: var(--text-primary);
  }

  .template-card__category {
      font-size: 11px;
      color: var(--text-tertiary);
      margin-top: 4px;
  }

  .template-card__preview {
      background: var(--gray-50);
      border: 1px solid var(--border);
      border-radius: var(--radius-md);
      padding: 12px;
      font-size: 12px;
      color: var(--text-secondary);
      line-height: 1.6;
      margin-bottom: 12px;
      font-family: 'Monaco', 'Menlo', monospace;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
      white-space: pre-wrap;
      overflow-wrap: break-word;
      height: 80px;
  }

  .template-card__meta {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
      margin-bottom: 12px;
  }

  .template-card__footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 12px;
      border-top: 1px solid var(--border);
  }

  /* Few-shot Card */
  .fewshot-card {
      background: var(--background);
      border: 1px solid var(--border);
      border-radius: var(--radius-lg);
      overflow: hidden;
      transition: all 0.2s;

      display: flex;
      flex-direction: column;
      height: 100%;
  }

  .fewshot-card:hover {
      box-shadow: var(--shadow-md);
  }

  .fewshot-card__header {
      padding: 16px;
      border-bottom: 1px solid var(--border);
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
  }

  .fewshot-card__title {
      font-size: 14px;
      font-weight: 600;
      color: var(--text-primary);
  }

  .fewshot-card__count {
      font-size: 11px;
      color: var(--text-tertiary);
      margin-top: 4px;
  }

  .fewshot-card__body {
      padding: 16px;
  }

  .fewshot-card__example {
      margin-bottom: 12px;
  }

  .fewshot-card__example:last-child {
      margin-bottom: 0;
  }

  .fewshot-card__label {
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      gap: 4px;
  }

  .fewshot-card__label--input {
      color: var(--info);
  }

  .fewshot-card__label--output {
      color: var(--success);
  }

  .fewshot-card__text {
      background: var(--gray-50);
      border-radius: var(--radius-sm);
      padding: 10px;
      font-size: 12px;
      color: var(--text-secondary);
      line-height: 1.5;
  }

  .fewshot-card__footer {
      padding: 12px 16px;
      border-top: 1px solid var(--border);
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: var(--gray-50);

      margin-top: auto;
  }

  .fewshot-card__meta {
      display: flex;
      align-items: center;
      gap: 8px;
  }

  /* Status Badge */
  .status-badge {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 4px 10px;
      border-radius: var(--radius-full);
      font-size: 11px;
      font-weight: 500;
  }

  .status-badge--active {
      background: var(--success-light);
      color: var(--success);
  }

  .status-badge--draft {
      background: var(--gray-100);
      color: var(--gray-500);
  }

  .status-badge__dot {
      width: 6px;
      height: 6px;
      border-radius: var(--radius-full);
      background: currentColor;
  }

  /* Modal */
  .partner-meterial-modal-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s;
  }

  .partner-meterial-modal-overlay--open {
      opacity: 1;
      visibility: visible;
  }

  .partner-meterial-modal {
      background: var(--background);
      border-radius: var(--radius-xl);
      width: 100%;
      max-width: 560px;
      max-height: 90vh;
      overflow: hidden;
      transform: scale(0.95);
      transition: all 0.3s;
  }

  .partner-meterial-modal-overlay--open .partner-meterial-modal {
      transform: scale(1);
  }

  .modal--lg {
      max-width: 720px;
  }

  .partner-meterial-modal__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 20px;
      border-bottom: 1px solid var(--border);
  }

  .modal__title {
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 8px;
  }

  .modal__close {
      width: 32px;
      height: 32px;
      border: none;
      background: transparent;
      border-radius: var(--radius-md);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--text-tertiary);
  }

  .modal__close:hover {
      background: var(--gray-100);
      color: var(--text-primary);
  }

  .partner-meterial-modal__body {
      padding: 20px;
      max-height: 60vh;
      overflow-y: auto;
  }

  .partner-meterial-modal__footer {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      padding: 16px 20px;
      border-top: 1px solid var(--border);
      background: var(--gray-50);
  }

  /* Form */
  .form-group {
      margin-bottom: 20px;
  }

  .form-group:last-child {
      margin-bottom: 0;
  }

  .form-label {
      display: block;
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 6px;
      color: var(--text-primary);
  }

  .form-label span {
      color: var(--error);
  }

  .form-hint {
      font-size: 11px;
      color: var(--text-tertiary);
      margin-top: 4px;
  }

  .form-input {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid var(--border);
      border-radius: var(--radius-md);
      font-size: 13px;
      font-family: var(--font-sans);
  }

  .form-input:focus {
      outline: none;
      border-color: var(--partner-primary-400);
      box-shadow: 0 0 0 3px var(--partner-primary-100);
  }

  .form-textarea {
      resize: vertical;
      min-height: 100px;
  }

  .form-textarea--code {
      font-family: 'Monaco', 'Menlo', monospace;
      font-size: 12px;
      background: var(--gray-900);
      color: #e2e8f0;
      border-color: var(--gray-700);
      min-height: 150px;
  }

  .form-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
  }

  /* Color Picker */
  .color-picker {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
  }

  .color-picker__item {
      width: 32px;
      height: 32px;
      border-radius: var(--radius-md);
      border: 2px solid transparent;
      cursor: pointer;
      transition: all 0.2s;
  }

  .color-picker__item:hover {
      transform: scale(1.1);
  }

  .color-picker__item--active {
      border-color: var(--text-primary);
      box-shadow: 0 0 0 2px white, 0 0 0 4px var(--text-primary);
  }

  /* Course Select */
  .course-checkboxes {
      display: flex;
      flex-direction: column;
      gap: 8px;
  }

  .course-checkbox {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 12px;
      border: 1px solid var(--border);
      border-radius: var(--radius-md);
      cursor: pointer;
      transition: all 0.2s;
  }

  .course-checkbox:hover {
      background: var(--surface);
  }

  .course-checkbox--checked {
      background: var(--partner-primary-50);
      border-color: var(--partner-primary-300);
  }

  .course-checkbox__input {
      width: 18px;
      height: 18px;
      accent-color: var(--partner-primary-600);
  }

  .course-checkbox__info {
      flex: 1 1;
  }

  .course-checkbox__name {
      font-size: 13px;
      font-weight: 500;
      color: var(--text-primary);
  }

  .course-checkbox__meta {
      font-size: 11px;
      color: var(--text-tertiary);
  }

  /* Few-shot Builder */
  .fewshot-builder {
      display: flex;
      flex-direction: column;
      gap: 12px;
  }

  .fewshot-item {
      background: var(--surface);
      border: 1px solid var(--border);
      border-radius: var(--radius-md);
      padding: 12px;
  }

  .fewshot-item__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
  }

  .fewshot-item__title {
      font-size: 12px;
      font-weight: 600;
      color: var(--text-secondary);
  }

  .fewshot-item__remove {
      font-size: 11px;
      color: var(--error);
      cursor: pointer;
  }

  .fewshot-item__row {
      margin-bottom: 10px;
  }

  .fewshot-item__row:last-child {
      margin-bottom: 0;
  }

  .fewshot-item__label {
      font-size: 11px;
      font-weight: 600;
      color: var(--text-tertiary);
      margin-bottom: 4px;
  }

  .fewshot-item__input {
      width: 100%;
      padding: 8px 10px;
      border: 1px solid var(--border);
      border-radius: var(--radius-sm);
      font-size: 12px;
      resize: none;
      font-family: var(--font-sans);

      min-height: 100px;
  }

  .fewshot-add {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      padding: 12px;
      border: 1px dashed var(--border);
      border-radius: var(--radius-md);
      font-size: 12px;
      color: var(--text-secondary);
      cursor: pointer;
  }

  .fewshot-add:hover {
      background: var(--surface);
      border-color: var(--partner-primary-300);
      color: var(--partner-primary-600);
  }

  /* Toast */
  .toast {
      position: fixed;
      bottom: 24px;
      right: 24px;
      padding: 12px 20px;
      background: var(--gray-800);
      color: white;
      border-radius: var(--radius-md);
      font-size: 13px;
      z-index: 99999;
      animation: slideIn 0.3s ease;
  }

  @keyframes slideIn {
      from {
          transform: translateX(100%);
          opacity: 0;
      }

      to {
          transform: translateX(0);
          opacity: 1;
      }
  }

  .toast--success {
      background: var(--success);
  }

  .toast--info {
      background: var(--info);
  }

  /* Dropdown Menu */
  .partner-dropdown {
      position: relative;
  }

  .dropdown__menu {
      position: absolute;
      top: 100%;
      right: 0;
      margin-top: 4px;
      min-width: 160px;
      background: var(--background);
      border: 1px solid var(--border);
      border-radius: var(--radius-lg);
      box-shadow: var(--shadow-lg);
      z-index: 100;
      opacity: 0;
      visibility: hidden;
      transform: translateY(-8px);
      transition: all 0.2s ease;
  }

  .dropdown--open .dropdown__menu,
  .dropdown__menu--open {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
  }

  .dropdown__item {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      padding: 10px 14px;
      border: none;
      background: transparent;
      font-size: 13px;
      color: var(--text-primary);
      cursor: pointer;
      text-align: left;
      transition: background 0.15s;
  }

  .dropdown__item:first-child {
      border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  }

  .dropdown__item:last-child {
      border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  }

  .dropdown__item:hover {
      background: var(--gray-50);
  }

  .dropdown__item--primary {
      color: var(--partner-primary-600);
  }

  .dropdown__item--primary:hover {
      background: var(--partner-primary-50);
  }

  .dropdown__item--warning {
      color: var(--warning);
  }

  .dropdown__item--warning:hover {
      background: var(--warning-light);
  }

  .dropdown__item--danger {
      color: var(--error);
  }

  .dropdown__item--danger:hover {
      background: var(--error-alert-bg);
  }

  .dropdown__divider {
      height: 1px;
      background: var(--border);
      margin: 4px 0;
  }

  /* Header Right Actions */
  .main-header__right {
      display: flex;
      align-items: center;
      gap: 8px;
  }

  .main-header__btn {
      width: 36px;
      height: 36px;
      border: 1px solid var(--border);
      background: var(--background);
      border-radius: var(--radius-md);
      cursor: pointer;
      color: var(--text-secondary);
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
  }

  .main-header__btn:hover {
      background: var(--surface);
      border-color: var(--partner-primary-300);
      color: var(--partner-primary-600);
  }

  .main-header__badge {
      position: absolute;
      top: -4px;
      right: -4px;
      min-width: 18px;
      height: 18px;
      background: var(--error);
      color: white;
      font-size: 10px;
      font-weight: 600;
      border-radius: var(--radius-full);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 4px;
  }

  /* Notification Dropdown */
  .notification-dropdown {
      position: absolute;
      top: calc(100% + 8px);
      right: 0;
      width: 320px;
      background: var(--background);
      border: 1px solid var(--border);
      border-radius: var(--radius-lg);
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
      z-index: 1000;
      display: none;
  }

  .notification-dropdown--open {
      display: block;
  }

  .notification-dropdown__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      border-bottom: 1px solid var(--border);
  }

  .notification-dropdown__title {
      font-size: 14px;
      font-weight: 600;
      color: var(--text-primary);
  }

  .notification-dropdown__action {
      font-size: 12px;
      color: var(--partner-primary-600);
      cursor: pointer;
  }

  .notification-dropdown__action:hover {
      text-decoration: underline;
  }

  .notification-dropdown__list {
      max-height: 360px;
      overflow-y: auto;
  }

  .notification-dropdown__empty {
      padding: 40px 20px;
      text-align: center;
      color: var(--text-tertiary);
      font-size: 13px;
  }

  .notification-dropdown__footer {
      padding: 10px 16px;
      border-top: 1px solid var(--border);
      text-align: center;
  }

  .notification-dropdown__footer a {
      font-size: 12px;
      color: var(--partner-primary-600);
      text-decoration: none;
  }

  .notification-dropdown__footer a:hover {
      text-decoration: underline;
  }

  .notification-item {
      padding: 12px 16px;
      border-bottom: 1px solid var(--border);
      cursor: pointer;
      transition: background 0.15s;
  }

  .notification-item:hover {
      background: var(--surface);
  }

  .notification-item:last-child {
      border-bottom: none;
  }

  .notification-item--unread {
      background: var(--partner-primary-50);
  }

  .notification-item--unread:hover {
      background: var(--partner-primary-100);
  }

  .notification-item__text {
      font-size: 13px;
      color: var(--text-primary);
      line-height: 1.5;
  }

  .notification-item__text strong {
      font-weight: 600;
  }

  .notification-item__time {
      font-size: 11px;
      color: var(--text-tertiary);
      margin-top: 4px;
  }

  .notification-group {
      padding: 8px 16px 4px;
      font-size: 11px;
      font-weight: 600;
      color: var(--text-tertiary);
      text-transform: uppercase;
      background: var(--surface);
  }`, "",{"version":3,"sources":["webpack://./src/css/PartnerInstructorMaterials.css"],"names":[],"mappings":"EAAE,SAAS;EACT;MACI,SAAO;MACP,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,0BAA0B;EAC9B;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,kBAAkB;MAClB,6BAA6B;MAC7B,sCAAsC;EAC1C;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,SAAS;EACb;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,0BAA0B;EAC9B;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,QAAQ;EACZ;;EAEA;MACI,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,QAAQ;MACR,iBAAiB;MACjB,YAAY;MACZ,+BAA+B;MAC/B,eAAe;MACf,gBAAgB;MAChB,eAAe;MACf,wFAAwF;EAC5F;;EAEA;MACI,2FAA2F;MAC3F,YAAY;EAChB;;EAEA;MACI,2FAA2F;EAC/F;;EAEA;MACI,6BAA6B;MAC7B,+BAA+B;MAC/B,0BAA0B;EAC9B;;EAEA;MACI,0BAA0B;MAC1B,wCAAwC;EAC5C;;EAEA;MACI,wBAAwB;MACxB,YAAY;MACZ,mDAAmD;EACvD;;EAEA;MACI,6BAA6B;EACjC;;EAEA;MACI,iBAAiB;MACjB,eAAe;EACnB;;EAEA;MACI,SAAO;MACP,gBAAgB;MAChB,aAAa;EACjB;;EAEA,SAAS;EACT;MACI,aAAa;MACb,QAAQ;MACR,2BAA2B;MAC3B,YAAY;MACZ,+BAA+B;MAC/B,mBAAmB;MACnB,kBAAkB;EACtB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,kBAAkB;MAClB,YAAY;MACZ,uBAAuB;MACvB,+BAA+B;MAC/B,eAAe;MACf,gBAAgB;MAChB,4BAA4B;MAC5B,eAAe;MACf,oBAAoB;EACxB;;EAEA;MACI,0BAA0B;EAC9B;;EAEA;MACI,6BAA6B;MAC7B,iCAAiC;MACjC,4BAA4B;EAChC;;EAEA;MACI,eAAe;MACf,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,sCAAsC;MACtC,iCAAiC;MACjC,eAAe;MACf,gBAAgB;MAChB,iCAAiC;MACjC,cAAc;EAClB;;EAEA;MACI,sCAAsC;MACtC,YAAY;EAChB;;EAEA;MACI,aAAa;EACjB;;EAEA;MACI,cAAc;EAClB;;EAEA,cAAc;EACd;MACI,aAAa;MACb,qCAAqC;MACrC,SAAS;MACT,mBAAmB;EACvB;;EAEA;MACI,6BAA6B;MAC7B,+BAA+B;MAC/B,+BAA+B;MAC/B,aAAa;MACb,aAAa;MACb,mBAAmB;MACnB,SAAS;EACb;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,+BAA+B;MAC/B,aAAa;MACb,mBAAmB;MACnB,uBAAuB;EAC3B;;EAEA;MACI,sCAAsC;MACtC,iCAAiC;EACrC;;EAEA;MACI,gCAAgC;MAChC,qBAAqB;EACzB;;EAEA;MACI,8BAA8B;MAC9B,yBAAyB;EAC7B;;EAEA;MACI,SAAO;EACX;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,0BAA0B;EAC9B;;EAEA;MACI,eAAe;MACf,2BAA2B;EAC/B;;EAEA,SAAS;EACT;MACI,aAAa;MACb,4DAA4D;MAC5D,SAAS;EACb;;EAEA,eAAe;EACf;MACI,6BAA6B;MAC7B,+BAA+B;MAC/B,+BAA+B;MAC/B,aAAa;MACb,kBAAkB;MAClB,oBAAoB;MACpB,kBAAkB;EACtB;;EAEA;;;;;;;;;KASG;;EAEH;MACI,4BAA4B;MAC5B,wCAAwC;EAC5C;;EAEA,gBAAgB;EAChB;MACI,qDAAqD;EACzD;;EAEA;MACI,qDAAqD;EACzD;;EAEA;MACI,qDAAqD;EACzD;;EAEA;MACI,qDAAqD;EACzD;;EAEA;MACI,qDAAqD;EACzD;;EAEA;MACI,qDAAqD;EACzD;;EAEA;MACI,qDAAqD;EACzD;;EAEA;MACI,qDAAqD;EACzD;;EAEA;MACI,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,UAAU;EACd;;EAEA;MACI,aAAa;MACb,sBAAsB;MACtB,QAAQ;MACR,mBAAmB;EACvB;;EAEA;MACI,SAAO;MACP,YAAY;EAChB;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,0BAA0B;MAC1B,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,QAAQ;EACZ;;EAEA;MACI,eAAe;MACf,4BAA4B;MAC5B,gBAAgB;MAChB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;MAC5B,gBAAgB;EACpB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,6BAA6B;MAC7B,+BAA+B;MAC/B,eAAe;MACf,2BAA2B;MAC3B,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,4BAA4B;MAC5B,cAAc;EAClB;;EAEA;MACI,2BAA2B;MAC3B,0BAA0B;EAC9B;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,mBAAmB;MACnB,eAAe;EACnB;;EAEA;MACI,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;MACR,eAAe;MACf,gBAAgB;MAChB,gBAAgB;MAChB,+BAA+B;EACnC;;EAEA;MACI,2BAA2B;MAC3B,4BAA4B;EAChC;;EAEA;MACI,qCAAqC;MACrC,iCAAiC;EACrC;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,iBAAiB;MACjB,mCAAmC;EACvC;;EAEA;MACI,eAAe;MACf,2BAA2B;MAC3B,aAAa;MACb,mBAAmB;MACnB,QAAQ;EACZ;;EAEA;MACI,aAAa;MACb,QAAQ;EACZ;;EAEA,kBAAkB;EAClB;MACI,6BAA6B;MAC7B,+BAA+B;MAC/B,+BAA+B;MAC/B,sBAAsB;MACtB,oBAAoB;EACxB;;EAEA;MACI,4BAA4B;EAChC;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,aAAa;MACb,uBAAuB;EAC3B;;EAEA;MACI,aAAa;MACb,uBAAuB;MACvB,8BAA8B;MAC9B,mBAAmB;EACvB;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,0BAA0B;EAC9B;;EAEA;MACI,eAAe;MACf,2BAA2B;MAC3B,eAAe;EACnB;;EAEA;MACI,0BAA0B;MAC1B,+BAA+B;MAC/B,+BAA+B;MAC/B,aAAa;MACb,eAAe;MACf,4BAA4B;MAC5B,gBAAgB;MAChB,mBAAmB;MACnB,yCAAyC;MACzC,oBAAoB;MACpB,qBAAqB;MACrB,aAAa;MACb,4BAA4B;MAC5B,gBAAgB;MAChB,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,yBAAyB;MACzB,YAAY;EAChB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,eAAe;MACf,mBAAmB;EACvB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,iBAAiB;MACjB,mCAAmC;EACvC;;EAEA,kBAAkB;EAClB;MACI,6BAA6B;MAC7B,+BAA+B;MAC/B,+BAA+B;MAC/B,gBAAgB;MAChB,oBAAoB;;MAEpB,aAAa;MACb,sBAAsB;MACtB,YAAY;EAChB;;EAEA;MACI,4BAA4B;EAChC;;EAEA;MACI,aAAa;MACb,sCAAsC;MACtC,aAAa;MACb,uBAAuB;MACvB,8BAA8B;EAClC;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,0BAA0B;EAC9B;;EAEA;MACI,eAAe;MACf,2BAA2B;MAC3B,eAAe;EACnB;;EAEA;MACI,aAAa;EACjB;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,gBAAgB;EACpB;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,yBAAyB;MACzB,qBAAqB;MACrB,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,QAAQ;EACZ;;EAEA;MACI,kBAAkB;EACtB;;EAEA;MACI,qBAAqB;EACzB;;EAEA;MACI,0BAA0B;MAC1B,+BAA+B;MAC/B,aAAa;MACb,eAAe;MACf,4BAA4B;MAC5B,gBAAgB;EACpB;;EAEA;MACI,kBAAkB;MAClB,mCAAmC;MACnC,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,0BAA0B;;MAE1B,gBAAgB;EACpB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,QAAQ;EACZ;;EAEA,iBAAiB;EACjB;MACI,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;MACR,iBAAiB;MACjB,iCAAiC;MACjC,eAAe;MACf,gBAAgB;EACpB;;EAEA;MACI,gCAAgC;MAChC,qBAAqB;EACzB;;EAEA;MACI,2BAA2B;MAC3B,sBAAsB;EAC1B;;EAEA;MACI,UAAU;MACV,WAAW;MACX,iCAAiC;MACjC,wBAAwB;EAC5B;;EAEA,UAAU;EACV;MACI,eAAe;MACf,QAAQ;MACR,8BAA8B;MAC9B,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,aAAa;MACb,UAAU;MACV,kBAAkB;MAClB,oBAAoB;EACxB;;EAEA;MACI,UAAU;MACV,mBAAmB;EACvB;;EAEA;MACI,6BAA6B;MAC7B,+BAA+B;MAC/B,WAAW;MACX,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB;MAChB,sBAAsB;MACtB,oBAAoB;EACxB;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,gBAAgB;EACpB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,kBAAkB;MAClB,sCAAsC;EAC1C;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,QAAQ;EACZ;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,uBAAuB;MACvB,+BAA+B;MAC/B,eAAe;MACf,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,2BAA2B;EAC/B;;EAEA;MACI,2BAA2B;MAC3B,0BAA0B;EAC9B;;EAEA;MACI,aAAa;MACb,gBAAgB;MAChB,gBAAgB;EACpB;;EAEA;MACI,aAAa;MACb,yBAAyB;MACzB,QAAQ;MACR,kBAAkB;MAClB,mCAAmC;MACnC,0BAA0B;EAC9B;;EAEA,SAAS;EACT;MACI,mBAAmB;EACvB;;EAEA;MACI,gBAAgB;EACpB;;EAEA;MACI,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,0BAA0B;EAC9B;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,eAAe;MACf,2BAA2B;MAC3B,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,kBAAkB;MAClB,+BAA+B;MAC/B,+BAA+B;MAC/B,eAAe;MACf,6BAA6B;EACjC;;EAEA;MACI,aAAa;MACb,wCAAwC;MACxC,gDAAgD;EACpD;;EAEA;MACI,gBAAgB;MAChB,iBAAiB;EACrB;;EAEA;MACI,yCAAyC;MACzC,eAAe;MACf,2BAA2B;MAC3B,cAAc;MACd,6BAA6B;MAC7B,iBAAiB;EACrB;;EAEA;MACI,aAAa;MACb,8BAA8B;MAC9B,SAAS;EACb;;EAEA,iBAAiB;EACjB;MACI,aAAa;MACb,QAAQ;MACR,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,+BAA+B;MAC/B,6BAA6B;MAC7B,eAAe;MACf,oBAAoB;EACxB;;EAEA;MACI,qBAAqB;EACzB;;EAEA;MACI,iCAAiC;MACjC,0DAA0D;EAC9D;;EAEA,kBAAkB;EAClB;MACI,aAAa;MACb,sBAAsB;MACtB,QAAQ;EACZ;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,kBAAkB;MAClB,+BAA+B;MAC/B,+BAA+B;MAC/B,eAAe;MACf,oBAAoB;EACxB;;EAEA;MACI,0BAA0B;EAC9B;;EAEA;MACI,qCAAqC;MACrC,wCAAwC;EAC5C;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,wCAAwC;EAC5C;;EAEA;MACI,SAAO;EACX;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,0BAA0B;EAC9B;;EAEA;MACI,eAAe;MACf,2BAA2B;EAC/B;;EAEA,qBAAqB;EACrB;MACI,aAAa;MACb,sBAAsB;MACtB,SAAS;EACb;;EAEA;MACI,0BAA0B;MAC1B,+BAA+B;MAC/B,+BAA+B;MAC/B,aAAa;EACjB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,mBAAmB;EACvB;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,4BAA4B;EAChC;;EAEA;MACI,eAAe;MACf,mBAAmB;MACnB,eAAe;EACnB;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,gBAAgB;EACpB;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,2BAA2B;MAC3B,kBAAkB;EACtB;;EAEA;MACI,WAAW;MACX,iBAAiB;MACjB,+BAA+B;MAC/B,+BAA+B;MAC/B,eAAe;MACf,YAAY;MACZ,6BAA6B;;MAE7B,iBAAiB;EACrB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,QAAQ;MACR,aAAa;MACb,gCAAgC;MAChC,+BAA+B;MAC/B,eAAe;MACf,4BAA4B;MAC5B,eAAe;EACnB;;EAEA;MACI,0BAA0B;MAC1B,wCAAwC;MACxC,iCAAiC;EACrC;;EAEA,UAAU;EACV;MACI,eAAe;MACf,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,2BAA2B;MAC3B,YAAY;MACZ,+BAA+B;MAC/B,eAAe;MACf,cAAc;MACd,4BAA4B;EAChC;;EAEA;MACI;UACI,2BAA2B;UAC3B,UAAU;MACd;;MAEA;UACI,wBAAwB;UACxB,UAAU;MACd;EACJ;;EAEA;MACI,0BAA0B;EAC9B;;EAEA;MACI,uBAAuB;EAC3B;;EAEA,kBAAkB;EAClB;MACI,kBAAkB;EACtB;;EAEA;MACI,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,eAAe;MACf,gBAAgB;MAChB,6BAA6B;MAC7B,+BAA+B;MAC/B,+BAA+B;MAC/B,4BAA4B;MAC5B,YAAY;MACZ,UAAU;MACV,kBAAkB;MAClB,2BAA2B;MAC3B,yBAAyB;EAC7B;;EAEA;;MAEI,UAAU;MACV,mBAAmB;MACnB,wBAAwB;EAC5B;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,YAAY;MACZ,uBAAuB;MACvB,eAAe;MACf,0BAA0B;MAC1B,eAAe;MACf,gBAAgB;MAChB,4BAA4B;EAChC;;EAEA;MACI,oDAAoD;EACxD;;EAEA;MACI,oDAAoD;EACxD;;EAEA;MACI,0BAA0B;EAC9B;;EAEA;MACI,iCAAiC;EACrC;;EAEA;MACI,qCAAqC;EACzC;;EAEA;MACI,qBAAqB;EACzB;;EAEA;MACI,gCAAgC;EACpC;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,iCAAiC;EACrC;;EAEA;MACI,WAAW;MACX,yBAAyB;MACzB,aAAa;EACjB;;EAEA,yBAAyB;EACzB;MACI,aAAa;MACb,mBAAmB;MACnB,QAAQ;EACZ;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,+BAA+B;MAC/B,6BAA6B;MAC7B,+BAA+B;MAC/B,eAAe;MACf,4BAA4B;MAC5B,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;EACtB;;EAEA;MACI,0BAA0B;MAC1B,wCAAwC;MACxC,iCAAiC;EACrC;;EAEA;MACI,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,eAAe;MACf,YAAY;MACZ,wBAAwB;MACxB,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,iCAAiC;MACjC,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;EAClB;;EAEA,0BAA0B;EAC1B;MACI,kBAAkB;MAClB,qBAAqB;MACrB,QAAQ;MACR,YAAY;MACZ,6BAA6B;MAC7B,+BAA+B;MAC/B,+BAA+B;MAC/B,2CAA2C;MAC3C,aAAa;MACb,aAAa;EACjB;;EAEA;MACI,cAAc;EAClB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,kBAAkB;MAClB,sCAAsC;EAC1C;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,0BAA0B;EAC9B;;EAEA;MACI,eAAe;MACf,iCAAiC;MACjC,eAAe;EACnB;;EAEA;MACI,0BAA0B;EAC9B;;EAEA;MACI,iBAAiB;MACjB,gBAAgB;EACpB;;EAEA;MACI,kBAAkB;MAClB,kBAAkB;MAClB,2BAA2B;MAC3B,eAAe;EACnB;;EAEA;MACI,kBAAkB;MAClB,mCAAmC;MACnC,kBAAkB;EACtB;;EAEA;MACI,eAAe;MACf,iCAAiC;MACjC,qBAAqB;EACzB;;EAEA;MACI,0BAA0B;EAC9B;;EAEA;MACI,kBAAkB;MAClB,sCAAsC;MACtC,eAAe;MACf,4BAA4B;EAChC;;EAEA;MACI,0BAA0B;EAC9B;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,qCAAqC;EACzC;;EAEA;MACI,sCAAsC;EAC1C;;EAEA;MACI,eAAe;MACf,0BAA0B;MAC1B,gBAAgB;EACpB;;EAEA;MACI,gBAAgB;EACpB;;EAEA;MACI,eAAe;MACf,2BAA2B;MAC3B,eAAe;EACnB;;EAEA;MACI,qBAAqB;MACrB,eAAe;MACf,gBAAgB;MAChB,2BAA2B;MAC3B,yBAAyB;MACzB,0BAA0B;EAC9B","sourcesContent":["  /* Main */\n  .main {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      min-width: 0;\n      background: var(--surface);\n  }\n\n  .main-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 12px 20px;\n      background: var(--background);\n      border-bottom: 1px solid var(--border);\n  }\n\n  .main-header__left {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n  }\n\n  .main-header__title {\n      font-size: 16px;\n      font-weight: 600;\n      color: var(--text-primary);\n  }\n\n  .main-header__right {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n  }\n\n  .btn {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      gap: 6px;\n      padding: 8px 16px;\n      border: none;\n      border-radius: var(--radius-md);\n      font-size: 13px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: background-color var(--transition-fast), border-color var(--transition-fast);\n  }\n\n  .partner-btn--primary {\n      background: linear-gradient(135deg, var(--partner-primary-500), var(--partner-primary-600));\n      color: white;\n  }\n\n  .partner-btn--primary:hover {\n      background: linear-gradient(135deg, var(--partner-primary-600), var(--partner-primary-700));\n  }\n\n  .btn--secondary {\n      background: var(--background);\n      border: 1px solid var(--border);\n      color: var(--text-primary);\n  }\n\n  .btn--secondary:hover {\n      background: var(--surface);\n      border-color: var(--partner-primary-300);\n  }\n\n  .btn--danger {\n      background: var(--error);\n      color: white;\n      transition: background-color var(--transition-fast);\n  }\n\n  .btn--danger:hover {\n      background: var(--error-dark);\n  }\n\n  .btn--sm {\n      padding: 6px 12px;\n      font-size: 12px;\n  }\n\n  .main-content {\n      flex: 1;\n      overflow-y: auto;\n      padding: 20px;\n  }\n\n  /* Tabs */\n  .partner-tabs {\n      display: flex;\n      gap: 4px;\n      background: var(--gray-100);\n      padding: 4px;\n      border-radius: var(--radius-lg);\n      margin-bottom: 20px;\n      width: fit-content;\n  }\n\n  .partner-tab {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 10px 20px;\n      border: none;\n      background: transparent;\n      border-radius: var(--radius-md);\n      font-size: 13px;\n      font-weight: 500;\n      color: var(--text-secondary);\n      cursor: pointer;\n      transition: all 0.2s;\n  }\n\n  .partner-tab:hover {\n      color: var(--text-primary);\n  }\n\n  .partner-tab--active {\n      background: var(--background);\n      color: var(--partner-primary-600);\n      box-shadow: var(--shadow-sm);\n  }\n\n  .partner-tab__badge {\n      min-width: 20px;\n      height: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: var(--partner-primary-100);\n      color: var(--partner-primary-600);\n      font-size: 11px;\n      font-weight: 600;\n      border-radius: var(--radius-full);\n      padding: 0 6px;\n  }\n\n  .partner-tab--active .partner-tab__badge {\n      background: var(--partner-primary-600);\n      color: white;\n  }\n\n  .partner-tab-content {\n      display: none;\n  }\n\n  .partner-tab-content--active {\n      display: block;\n  }\n\n  /* Stats Row */\n  .stats-row {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 16px;\n      margin-bottom: 20px;\n  }\n\n  .stat-mini {\n      background: var(--background);\n      border: 1px solid var(--border);\n      border-radius: var(--radius-lg);\n      padding: 16px;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n  }\n\n  .stat-mini__icon {\n      width: 40px;\n      height: 40px;\n      border-radius: var(--radius-md);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n  }\n\n  .stat-mini__icon--blue {\n      background: var(--partner-primary-100);\n      color: var(--partner-primary-600);\n  }\n\n  .stat-mini__icon--green {\n      background: var(--success-light);\n      color: var(--success);\n  }\n\n  .stat-mini__icon--purple {\n      background: var(--primary-100);\n      color: var(--primary-600);\n  }\n\n  .stat-mini__info {\n      flex: 1;\n  }\n\n  .stat-mini__value {\n      font-size: 20px;\n      font-weight: 700;\n      color: var(--text-primary);\n  }\n\n  .stat-mini__label {\n      font-size: 12px;\n      color: var(--text-tertiary);\n  }\n\n  /* Grid */\n  .items-grid {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n      gap: 16px;\n  }\n\n  /* Agent Card */\n  .agent-card {\n      background: var(--background);\n      border: 1px solid var(--border);\n      border-radius: var(--radius-lg);\n      padding: 20px;\n      padding-left: 24px;\n      transition: all 0.2s;\n      position: relative;\n  }\n\n  /* .agent-card::before {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      width: 4px;\n      background: var(--gray-300);\n      border-radius: var(--radius-lg) 0 0 var(--radius-lg);\n  } */\n\n  .agent-card:hover {\n      box-shadow: var(--shadow-md);\n      border-color: var(--partner-primary-300);\n  }\n\n  /* Card Colors */\n  .agent-card--purple::before {\n      background: linear-gradient(180deg, #a855f7, #7c3aed);\n  }\n\n  .agent-card--blue::before {\n      background: linear-gradient(180deg, #3b82f6, #2563eb);\n  }\n\n  .agent-card--teal::before {\n      background: linear-gradient(180deg, #14b8a6, #0d9488);\n  }\n\n  .agent-card--green::before {\n      background: linear-gradient(180deg, #22c55e, #16a34a);\n  }\n\n  .agent-card--orange::before {\n      background: linear-gradient(180deg, #f97316, #ea580c);\n  }\n\n  .agent-card--pink::before {\n      background: linear-gradient(180deg, #ec4899, #db2777);\n  }\n\n  .agent-card--red::before {\n      background: linear-gradient(180deg, #ef4444, #dc2626);\n  }\n\n  .agent-card--indigo::before {\n      background: linear-gradient(180deg, #6366f1, #4f46e5);\n  }\n\n  .agent-card>.partner-dropdown {\n      position: absolute;\n      top: 12px;\n      right: 12px;\n      z-index: 2;\n  }\n\n  .agent-card__header {\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n      margin-bottom: 12px;\n  }\n\n  .agent-card__info {\n      flex: 1;\n      min-width: 0;\n  }\n\n  .agent-card__name {\n      font-size: 15px;\n      font-weight: 600;\n      color: var(--text-primary);\n      margin-bottom: 6px;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n  }\n\n  .agent-card__desc {\n      font-size: 13px;\n      color: var(--text-secondary);\n      line-height: 1.5;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n  }\n\n  .agent-card__menu {\n      width: 32px;\n      height: 32px;\n      border: none;\n      background: var(--background);\n      border-radius: var(--radius-md);\n      cursor: pointer;\n      color: var(--text-tertiary);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: var(--shadow-sm);\n      flex-shrink: 0;\n  }\n\n  .agent-card__menu:hover {\n      background: var(--gray-100);\n      color: var(--text-primary);\n  }\n\n  .agent-card__meta {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      margin-bottom: 12px;\n      flex-wrap: wrap;\n  }\n\n  .agent-card__tag {\n      display: inline-flex;\n      align-items: center;\n      gap: 4px;\n      font-size: 11px;\n      font-weight: 500;\n      padding: 4px 8px;\n      border-radius: var(--radius-sm);\n  }\n\n  .agent-card__tag--model {\n      background: var(--gray-100);\n      color: var(--text-secondary);\n  }\n\n  .agent-card__tag--course {\n      background: var(--partner-primary-50);\n      color: var(--partner-primary-600);\n  }\n\n  .agent-card__footer {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding-top: 12px;\n      border-top: 1px solid var(--border);\n  }\n\n  .agent-card__stat {\n      font-size: 12px;\n      color: var(--text-tertiary);\n      display: flex;\n      align-items: center;\n      gap: 4px;\n  }\n\n  .agent-card__actions {\n      display: flex;\n      gap: 6px;\n  }\n\n  /* Template Card */\n  .template-card {\n      background: var(--background);\n      border: 1px solid var(--border);\n      border-radius: var(--radius-lg);\n      /* overflow: hidden; */\n      transition: all 0.2s;\n  }\n\n  .template-card:hover {\n      box-shadow: var(--shadow-md);\n  }\n\n  .template-card__color {\n      height: 4px;\n  }\n\n  .template-card__body {\n      padding: 16px;\n      /* min-height: 230px; */\n  }\n\n  .template-card__header {\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      margin-bottom: 12px;\n  }\n\n  .template-card__title {\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--text-primary);\n  }\n\n  .template-card__category {\n      font-size: 11px;\n      color: var(--text-tertiary);\n      margin-top: 4px;\n  }\n\n  .template-card__preview {\n      background: var(--gray-50);\n      border: 1px solid var(--border);\n      border-radius: var(--radius-md);\n      padding: 12px;\n      font-size: 12px;\n      color: var(--text-secondary);\n      line-height: 1.6;\n      margin-bottom: 12px;\n      font-family: 'Monaco', 'Menlo', monospace;\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      word-break: break-word;\n      white-space: pre-wrap;\n      overflow-wrap: break-word;\n      height: 80px;\n  }\n\n  .template-card__meta {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      flex-wrap: wrap;\n      margin-bottom: 12px;\n  }\n\n  .template-card__footer {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding-top: 12px;\n      border-top: 1px solid var(--border);\n  }\n\n  /* Few-shot Card */\n  .fewshot-card {\n      background: var(--background);\n      border: 1px solid var(--border);\n      border-radius: var(--radius-lg);\n      overflow: hidden;\n      transition: all 0.2s;\n\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n  }\n\n  .fewshot-card:hover {\n      box-shadow: var(--shadow-md);\n  }\n\n  .fewshot-card__header {\n      padding: 16px;\n      border-bottom: 1px solid var(--border);\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n  }\n\n  .fewshot-card__title {\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--text-primary);\n  }\n\n  .fewshot-card__count {\n      font-size: 11px;\n      color: var(--text-tertiary);\n      margin-top: 4px;\n  }\n\n  .fewshot-card__body {\n      padding: 16px;\n  }\n\n  .fewshot-card__example {\n      margin-bottom: 12px;\n  }\n\n  .fewshot-card__example:last-child {\n      margin-bottom: 0;\n  }\n\n  .fewshot-card__label {\n      font-size: 10px;\n      font-weight: 600;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      margin-bottom: 4px;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n  }\n\n  .fewshot-card__label--input {\n      color: var(--info);\n  }\n\n  .fewshot-card__label--output {\n      color: var(--success);\n  }\n\n  .fewshot-card__text {\n      background: var(--gray-50);\n      border-radius: var(--radius-sm);\n      padding: 10px;\n      font-size: 12px;\n      color: var(--text-secondary);\n      line-height: 1.5;\n  }\n\n  .fewshot-card__footer {\n      padding: 12px 16px;\n      border-top: 1px solid var(--border);\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      background: var(--gray-50);\n\n      margin-top: auto;\n  }\n\n  .fewshot-card__meta {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n  }\n\n  /* Status Badge */\n  .status-badge {\n      display: inline-flex;\n      align-items: center;\n      gap: 4px;\n      padding: 4px 10px;\n      border-radius: var(--radius-full);\n      font-size: 11px;\n      font-weight: 500;\n  }\n\n  .status-badge--active {\n      background: var(--success-light);\n      color: var(--success);\n  }\n\n  .status-badge--draft {\n      background: var(--gray-100);\n      color: var(--gray-500);\n  }\n\n  .status-badge__dot {\n      width: 6px;\n      height: 6px;\n      border-radius: var(--radius-full);\n      background: currentColor;\n  }\n\n  /* Modal */\n  .partner-meterial-modal-overlay {\n      position: fixed;\n      inset: 0;\n      background: rgba(0, 0, 0, 0.5);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      z-index: 1000;\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.3s;\n  }\n\n  .partner-meterial-modal-overlay--open {\n      opacity: 1;\n      visibility: visible;\n  }\n\n  .partner-meterial-modal {\n      background: var(--background);\n      border-radius: var(--radius-xl);\n      width: 100%;\n      max-width: 560px;\n      max-height: 90vh;\n      overflow: hidden;\n      transform: scale(0.95);\n      transition: all 0.3s;\n  }\n\n  .partner-meterial-modal-overlay--open .partner-meterial-modal {\n      transform: scale(1);\n  }\n\n  .modal--lg {\n      max-width: 720px;\n  }\n\n  .partner-meterial-modal__header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 16px 20px;\n      border-bottom: 1px solid var(--border);\n  }\n\n  .modal__title {\n      font-size: 16px;\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n  }\n\n  .modal__close {\n      width: 32px;\n      height: 32px;\n      border: none;\n      background: transparent;\n      border-radius: var(--radius-md);\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--text-tertiary);\n  }\n\n  .modal__close:hover {\n      background: var(--gray-100);\n      color: var(--text-primary);\n  }\n\n  .partner-meterial-modal__body {\n      padding: 20px;\n      max-height: 60vh;\n      overflow-y: auto;\n  }\n\n  .partner-meterial-modal__footer {\n      display: flex;\n      justify-content: flex-end;\n      gap: 8px;\n      padding: 16px 20px;\n      border-top: 1px solid var(--border);\n      background: var(--gray-50);\n  }\n\n  /* Form */\n  .form-group {\n      margin-bottom: 20px;\n  }\n\n  .form-group:last-child {\n      margin-bottom: 0;\n  }\n\n  .form-label {\n      display: block;\n      font-size: 13px;\n      font-weight: 500;\n      margin-bottom: 6px;\n      color: var(--text-primary);\n  }\n\n  .form-label span {\n      color: var(--error);\n  }\n\n  .form-hint {\n      font-size: 11px;\n      color: var(--text-tertiary);\n      margin-top: 4px;\n  }\n\n  .form-input {\n      width: 100%;\n      padding: 10px 12px;\n      border: 1px solid var(--border);\n      border-radius: var(--radius-md);\n      font-size: 13px;\n      font-family: var(--font-sans);\n  }\n\n  .form-input:focus {\n      outline: none;\n      border-color: var(--partner-primary-400);\n      box-shadow: 0 0 0 3px var(--partner-primary-100);\n  }\n\n  .form-textarea {\n      resize: vertical;\n      min-height: 100px;\n  }\n\n  .form-textarea--code {\n      font-family: 'Monaco', 'Menlo', monospace;\n      font-size: 12px;\n      background: var(--gray-900);\n      color: #e2e8f0;\n      border-color: var(--gray-700);\n      min-height: 150px;\n  }\n\n  .form-row {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 16px;\n  }\n\n  /* Color Picker */\n  .color-picker {\n      display: flex;\n      gap: 8px;\n      flex-wrap: wrap;\n  }\n\n  .color-picker__item {\n      width: 32px;\n      height: 32px;\n      border-radius: var(--radius-md);\n      border: 2px solid transparent;\n      cursor: pointer;\n      transition: all 0.2s;\n  }\n\n  .color-picker__item:hover {\n      transform: scale(1.1);\n  }\n\n  .color-picker__item--active {\n      border-color: var(--text-primary);\n      box-shadow: 0 0 0 2px white, 0 0 0 4px var(--text-primary);\n  }\n\n  /* Course Select */\n  .course-checkboxes {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n  }\n\n  .course-checkbox {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding: 10px 12px;\n      border: 1px solid var(--border);\n      border-radius: var(--radius-md);\n      cursor: pointer;\n      transition: all 0.2s;\n  }\n\n  .course-checkbox:hover {\n      background: var(--surface);\n  }\n\n  .course-checkbox--checked {\n      background: var(--partner-primary-50);\n      border-color: var(--partner-primary-300);\n  }\n\n  .course-checkbox__input {\n      width: 18px;\n      height: 18px;\n      accent-color: var(--partner-primary-600);\n  }\n\n  .course-checkbox__info {\n      flex: 1;\n  }\n\n  .course-checkbox__name {\n      font-size: 13px;\n      font-weight: 500;\n      color: var(--text-primary);\n  }\n\n  .course-checkbox__meta {\n      font-size: 11px;\n      color: var(--text-tertiary);\n  }\n\n  /* Few-shot Builder */\n  .fewshot-builder {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n  }\n\n  .fewshot-item {\n      background: var(--surface);\n      border: 1px solid var(--border);\n      border-radius: var(--radius-md);\n      padding: 12px;\n  }\n\n  .fewshot-item__header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 12px;\n  }\n\n  .fewshot-item__title {\n      font-size: 12px;\n      font-weight: 600;\n      color: var(--text-secondary);\n  }\n\n  .fewshot-item__remove {\n      font-size: 11px;\n      color: var(--error);\n      cursor: pointer;\n  }\n\n  .fewshot-item__row {\n      margin-bottom: 10px;\n  }\n\n  .fewshot-item__row:last-child {\n      margin-bottom: 0;\n  }\n\n  .fewshot-item__label {\n      font-size: 11px;\n      font-weight: 600;\n      color: var(--text-tertiary);\n      margin-bottom: 4px;\n  }\n\n  .fewshot-item__input {\n      width: 100%;\n      padding: 8px 10px;\n      border: 1px solid var(--border);\n      border-radius: var(--radius-sm);\n      font-size: 12px;\n      resize: none;\n      font-family: var(--font-sans);\n\n      min-height: 100px;\n  }\n\n  .fewshot-add {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 6px;\n      padding: 12px;\n      border: 1px dashed var(--border);\n      border-radius: var(--radius-md);\n      font-size: 12px;\n      color: var(--text-secondary);\n      cursor: pointer;\n  }\n\n  .fewshot-add:hover {\n      background: var(--surface);\n      border-color: var(--partner-primary-300);\n      color: var(--partner-primary-600);\n  }\n\n  /* Toast */\n  .toast {\n      position: fixed;\n      bottom: 24px;\n      right: 24px;\n      padding: 12px 20px;\n      background: var(--gray-800);\n      color: white;\n      border-radius: var(--radius-md);\n      font-size: 13px;\n      z-index: 99999;\n      animation: slideIn 0.3s ease;\n  }\n\n  @keyframes slideIn {\n      from {\n          transform: translateX(100%);\n          opacity: 0;\n      }\n\n      to {\n          transform: translateX(0);\n          opacity: 1;\n      }\n  }\n\n  .toast--success {\n      background: var(--success);\n  }\n\n  .toast--info {\n      background: var(--info);\n  }\n\n  /* Dropdown Menu */\n  .partner-dropdown {\n      position: relative;\n  }\n\n  .dropdown__menu {\n      position: absolute;\n      top: 100%;\n      right: 0;\n      margin-top: 4px;\n      min-width: 160px;\n      background: var(--background);\n      border: 1px solid var(--border);\n      border-radius: var(--radius-lg);\n      box-shadow: var(--shadow-lg);\n      z-index: 100;\n      opacity: 0;\n      visibility: hidden;\n      transform: translateY(-8px);\n      transition: all 0.2s ease;\n  }\n\n  .dropdown--open .dropdown__menu,\n  .dropdown__menu--open {\n      opacity: 1;\n      visibility: visible;\n      transform: translateY(0);\n  }\n\n  .dropdown__item {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      width: 100%;\n      padding: 10px 14px;\n      border: none;\n      background: transparent;\n      font-size: 13px;\n      color: var(--text-primary);\n      cursor: pointer;\n      text-align: left;\n      transition: background 0.15s;\n  }\n\n  .dropdown__item:first-child {\n      border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n  }\n\n  .dropdown__item:last-child {\n      border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n  }\n\n  .dropdown__item:hover {\n      background: var(--gray-50);\n  }\n\n  .dropdown__item--primary {\n      color: var(--partner-primary-600);\n  }\n\n  .dropdown__item--primary:hover {\n      background: var(--partner-primary-50);\n  }\n\n  .dropdown__item--warning {\n      color: var(--warning);\n  }\n\n  .dropdown__item--warning:hover {\n      background: var(--warning-light);\n  }\n\n  .dropdown__item--danger {\n      color: var(--error);\n  }\n\n  .dropdown__item--danger:hover {\n      background: var(--error-alert-bg);\n  }\n\n  .dropdown__divider {\n      height: 1px;\n      background: var(--border);\n      margin: 4px 0;\n  }\n\n  /* Header Right Actions */\n  .main-header__right {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n  }\n\n  .main-header__btn {\n      width: 36px;\n      height: 36px;\n      border: 1px solid var(--border);\n      background: var(--background);\n      border-radius: var(--radius-md);\n      cursor: pointer;\n      color: var(--text-secondary);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n  }\n\n  .main-header__btn:hover {\n      background: var(--surface);\n      border-color: var(--partner-primary-300);\n      color: var(--partner-primary-600);\n  }\n\n  .main-header__badge {\n      position: absolute;\n      top: -4px;\n      right: -4px;\n      min-width: 18px;\n      height: 18px;\n      background: var(--error);\n      color: white;\n      font-size: 10px;\n      font-weight: 600;\n      border-radius: var(--radius-full);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0 4px;\n  }\n\n  /* Notification Dropdown */\n  .notification-dropdown {\n      position: absolute;\n      top: calc(100% + 8px);\n      right: 0;\n      width: 320px;\n      background: var(--background);\n      border: 1px solid var(--border);\n      border-radius: var(--radius-lg);\n      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n      z-index: 1000;\n      display: none;\n  }\n\n  .notification-dropdown--open {\n      display: block;\n  }\n\n  .notification-dropdown__header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 12px 16px;\n      border-bottom: 1px solid var(--border);\n  }\n\n  .notification-dropdown__title {\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--text-primary);\n  }\n\n  .notification-dropdown__action {\n      font-size: 12px;\n      color: var(--partner-primary-600);\n      cursor: pointer;\n  }\n\n  .notification-dropdown__action:hover {\n      text-decoration: underline;\n  }\n\n  .notification-dropdown__list {\n      max-height: 360px;\n      overflow-y: auto;\n  }\n\n  .notification-dropdown__empty {\n      padding: 40px 20px;\n      text-align: center;\n      color: var(--text-tertiary);\n      font-size: 13px;\n  }\n\n  .notification-dropdown__footer {\n      padding: 10px 16px;\n      border-top: 1px solid var(--border);\n      text-align: center;\n  }\n\n  .notification-dropdown__footer a {\n      font-size: 12px;\n      color: var(--partner-primary-600);\n      text-decoration: none;\n  }\n\n  .notification-dropdown__footer a:hover {\n      text-decoration: underline;\n  }\n\n  .notification-item {\n      padding: 12px 16px;\n      border-bottom: 1px solid var(--border);\n      cursor: pointer;\n      transition: background 0.15s;\n  }\n\n  .notification-item:hover {\n      background: var(--surface);\n  }\n\n  .notification-item:last-child {\n      border-bottom: none;\n  }\n\n  .notification-item--unread {\n      background: var(--partner-primary-50);\n  }\n\n  .notification-item--unread:hover {\n      background: var(--partner-primary-100);\n  }\n\n  .notification-item__text {\n      font-size: 13px;\n      color: var(--text-primary);\n      line-height: 1.5;\n  }\n\n  .notification-item__text strong {\n      font-weight: 600;\n  }\n\n  .notification-item__time {\n      font-size: 11px;\n      color: var(--text-tertiary);\n      margin-top: 4px;\n  }\n\n  .notification-group {\n      padding: 8px 16px 4px;\n      font-size: 11px;\n      font-weight: 600;\n      color: var(--text-tertiary);\n      text-transform: uppercase;\n      background: var(--surface);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
